/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/11/15
 * @updateTime 2021/11/15
 * @decription 代码表对应的工具类
 */
import store from '@/store';

export default {

    /**
     * 获取代码map对象
     * @param {String} code 代码值
     * @returns {Promise}
     * */
    getCodeMap(code) {
        return new Promise((resolve, reject) => {
            // 请求对应的code类型请求
            store.dispatch('GetCodeType', code).then(() => {
                // 获取对应的codeMap对象
                resolve(store.getters.codeGetMap(code));
            })
                .catch(e => {
                    reject(e);
                })
        });
    },

    /**
     * 获取代码值对应的名称
     * */
    async getCodeName(code, keyId) {
        const _codeMap = await this.getCodeMap(code);
        if (!_codeMap) {
            return ''
        }
        return _codeMap[keyId] ? _codeMap[keyId].text : '';
    },

    /**
     * 获取代码值的名称
     * @returns {String} 名称
     * */
    getKeyName(codeMap, keyId) {
        return codeMap[keyId] ? codeMap[keyId].text : '';
    }
};
